import React from "react";
import classes from "./Button.module.css";

interface props {
  name: string;
  style?: any;
  onClick: () => void;
  type: any;
  classname?: any;
  icon?: any;
  disabled?: boolean;
}
function CommonButton({
  name,
  style,
  onClick,
  type,
  classname,
  icon,
  disabled = false,
}: props) {
  return (
    <>
      <button
        className={`${classname} ${classes.button_style} `}
        onClick={onClick}
        style={style}
        type={type}
        disabled={disabled}
      >
        {icon}
        {name}
      </button>
    </>
  );
}

export default CommonButton;
